import { VerificationMethodType } from '@treasury/domain/company/user';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/jha-wc';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { CompanyUserChallengeDetailsViewModel } from '../../company-user-challenge-details.vm';

@customElement('tm-bo-oob-details')
export class OutOfBandDetails extends TmBaseComponent {
    @property({ type: Object })
    public challengeDetails?: CompanyUserChallengeDetailsViewModel;

    @property({})
    public verificationMethodType?: VerificationMethodType;

    public render() {
        return html`<div class="mb-5">
                <label>Text Message (SMS) Phone #:</label>
                <span>${this.challengeDetails?.textNumber}</span>
            </div>
            <div class="mb-5">
                <label>Automated Phone Call #:</label>
                <span>${this.challengeDetails?.phoneNumber}</span>
            </div>
            <tm-radio-button
                name="changePasswordType"
                label="Preferred Verification Method:"
                ?disabled=${true}
                class="mb-4"
                .initial=${this.verificationMethodType}
                @change=${(e: CustomEvent) => this.handleOobVerificationMethodTypeChange(e)}
                .options=${this.challengeDetails?.verificationMethodOptions}
            ></tm-radio-button>
            <div class="mb-5">
                <label>Pin Collected:</label>
                <div>
                    <span class="bold">
                        ${this.challengeDetails?.isOobPinCollected === true ? 'Yes' : 'No'}
                    </span>
                </div>
            </div>`;
    }

    private handleOobVerificationMethodTypeChange(e: CustomEvent) {
        this.dispatchEvent(
            new CustomEvent<VerificationMethodType>('verification-method-change', {
                detail: e.detail.value,
            })
        );
    }

    public static get styles() {
        return css`
            :host {
                --radio-label-font-weight: 700;
            }
        `;
    }
}
